// 用户自定义内容长度限制
export const UGC_MAX_LENGTH = {
    // 用户
    USER: {
        CORP_NAME: 50, // 企业名称 50
        USER_NICKNAME: 80, // 用户昵称 80
        MEMBER_NICKNAME: 80, // 通讯录姓名 80
        EMAIL: 100, // 邮箱 100
        COMPANY_NAME: 50 // 公司名称 50
    },
    // 互联
    CORP_COOP: {
        DOCKER_NAME: 80, // 对接人姓名 80
        DOCKER_EMAIL: 100, // 对接人邮箱 100
        ROLE_NAME: 32, // 对接人角色名称 32
        LABEL_NAME: 32 // 企业标签名称 32
    },
    // 通讯录
    CONTACTS: {
        DEPT_NAME: 50, // 部门名称
        MEMBER_NAME: 80, // 成员姓名 80
        MEMBER_ID: 70, // 成员编号 70
        ROLE_GROUP: 32, // 角色组名称 32
        ROLE_NAME: 32, // 角色名称 32
        MANAGER_NAME: 32 // 管理组名称 32
    },
    // 导航栏
    NAV: {
        COOP_CORP: 50, // 互联组织 50
        HEADER_TITLE: 100 // 【通用】导航栏标题 100
    },
    /** 开放平台 */
    OPEN: {
        /** API Key 名字长度 */
        API_KEY_NAME: 64,
        /** API Key 白名单IP个数 */
        IP_NUM: 50,
        /** API Key 个数 */
        API_KEY: 500,
        /** API Key 应用授权个数 */
        APP_SCOPE: 50,
        /** 对话消息 */
        CHAT_MSG: 10000,
        // 自建应用 个数限制
        APP_COUNT: 50,
        /** 集成应用 名称长度 */
        APP_NAME: 100,
        /** 集成应用 描述长度 */
        APP_DESC: 200,
        /** 白名单域名个数限制 */
        APP_DOMAIN_MAX: 5,
        // mcp 服务名称长度
        MCP_NAME: 100,
        /** MCP 服务个数上限 */
        MCP_COUNT: 50,
        /** MCP 能力申请理由长度 */
        MCP_APPLY_REASON: 200,
        /** MCP 审核拒绝理由长度 */
        MCP_REJECT_REASON: 200,
        /** 自定义插件运行环境名称长度 */
        CUSTOM_RUNTIME_NAME: 32,
        /** 自定义插件运行环境数量上限 */
        CUSTOM_RUNTIME_COUNT: 2
    }
};
